export default "__VITE_ASSET__d0c470b7__"